<template>
	<div>
	    <header-view></header-view>
	    <nav-view></nav-view>
	    <footer-view></footer-view>
	</div>
</template>

<script type="text/ecmascript-6">
	import HeaderView from 'base/headeren/header'
	import NavView from 'base/naven/nav'
	import FooterView from 'base/footeren/footer'
	export default {
	  	components: {
	  		HeaderView,
	  		NavView,
	  		FooterView
	  	},
		created(){
			document.body.style.overflow='';
		},
		mounted(){
			//图片游览按返回键退出游览
		    this.$preview.on('imageLoadComplete', (e, item) =>{
		        let _preview = this.$preview.self;
		        let lookUrl = window.location.href + '&look';
		        window.history.pushState(null, null, lookUrl);
		        _preview.listen('close',
		        function() {
		            if (window.location.href.indexOf('&look') !== -1) {
		                window.history.back();
		            }
		        });
		        window.onhashchange = function() {
		            if (_preview !== null && _preview !== undefined) {
		                _preview.close();
		                _preview = null;
		            }
		        };
		    });
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/base/sidebaren/sidebar.vue